import axios from "Services/api";
import { toast } from "react-toastify";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { translation } from "Slices/translation/reducer";

export const getProfile = createAsyncThunk("profile/getProfileInfo", async (thunkAPI) => {
  try {
    const response = await axios.get(`/GetProfileInfo`);
    return response.data;
  } catch (error) {
    toast.error(translation?.Settings?.SomethingWentWrong || error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const updateProfile = createAsyncThunk("profile/updateProfileInfo", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/UpdateProfileInfo`, data);
    toast.success(translation?.Settings?.ProfileInfoUpdated || response.message);
    return response.data;
  } catch (error) {
    toast.error(translation?.Settings?.SomethingWentWrong || error.message);
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const updateProfilePicture = createAsyncThunk("profile/updateProfilePicture", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/UpdateProfilePicture`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error || "Something went wrong");
  }
});

export const getExperience = createAsyncThunk("profile/getExperience", async (thunkAPI) => {
  try {
    const response = await axios.get(`/GetUserExperience`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const addExperience = createAsyncThunk("profile/addExperience", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/AddUserExperience`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const updateExperience = createAsyncThunk("profile/updateExperience", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/UpdateUserExperience`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const deleteExperience = createAsyncThunk("profile/deleteExperience", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/DeleteUserExperience`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const getSkills = createAsyncThunk("profile/getSkills", async (thunkAPI) => {
  try {
    const response = await axios.get(`/GetUserSkills`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const addSkills = createAsyncThunk("profile/addSkills", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/AddUserSkills`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const updateSkills = createAsyncThunk("profile/updateSkills", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/UpdateUserSkills`, data);
    return response.data;
  } catch (error) {
     return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

export const deleteSkills = createAsyncThunk("profile/deleteSkills", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/DeleteUserSkills`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});

// export const sendOTP = createAsyncThunk("profile/sendOtp", async (data) => {
//   try {
//     const response = await axios.post(`/SendOTP`, data);
//     return response.data;
//   } catch (error) {
//     return error;
//   }
// });

export const verifyOTP = createAsyncThunk("profile/verifyOtp", async (data, thunkAPI) => {
  try {
    const response = await axios.post(`/VerifyOTP`, data);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error || "Something went wrong");
  }
});